import { AppLayoutSettings } from "../../common/styles/common.styles";

export const iconStyle = (): React.CSSProperties => {
  return {
    color: AppLayoutSettings.getAppColorContainer().primaryWidgetColor.value,
    fontSize: AppLayoutSettings.AppFontSize.extraLargeFontSizePx,
    padding: '0px 16px 4px 0px',
    cursor: 'pointer'
  }
};

export const getComponentRootContainerProperties = (): React.CSSProperties => {
    const CSSProperties: React.CSSProperties = {
        height: '20px',
        flexDirection: 'row',
        display: 'flex'
    };

    return CSSProperties;
};
